import { useState, useEffect } from "react";
import { apiClient } from "../axios/apiClient";

export const useFetch = (url, enable = true) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enable || !url) return;
    setLoading(true);
    setError(null);

    apiClient
      .get(url)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((err) => {
        console.log(err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, [url, enable]);

  return { data, loading, error };
};
